module.exports = __webpack_public_path__ + "2620c8c2/img/placeholder.888fcd0b.svg";